export const zodiacDetail = {
  header: {
    title: '生肖運勢',
    tag: '屬馬',
    manage: '檔案管理',
    solarLabel: '公曆',
    zodiacLabel: '生肖：',
  },
  tabs: {
    portrait: '運勢畫像',
    daily: '每日運勢',
    year: '生肖运势',
    
    conflict: '沖煞生肖',
    ninePurple: '九紫離火運',
    match: '生肖匹配',
    pairTest: '配对测试',
    hero: '本命英雄',
    fortune: '流年運勢',
  },
  daily: {
    traitTitle: '今日天賦特質',
    traitHint: '了解您今日最該發揮的天賦優勢 →',
    todayAdvice: '今日建議：',
    dimensionTitle: '今日四維詳情',
    dimensionHint: '點擊展開詳析',
    love: '愛情',
    career: '事業',
    wealth: '財運',
    health: '健康',
    luckyTitle: '今日幸運元素',
    luckyHint: '點擊查看含義',
    luckyColor: '幸運顏色',
    luckyNumber: '幸運數字',
    luckyNumberMeaning: '今日幸運數字為{{numbers}}。可以將這些數字融入日常：選擇含有這些數字的時段行動，或者在重要決策時以這些數字為參考。數字能量是一種微妙的共振，用好了是額外的助力。',
    luckyDirection: '幸運方位',
    luckyTime: '幸運時辰',
    actionTitle: '今日行動清單',
    actionHigh: '旺勢出擊',
    actionMid: '穩步推進',
    actionLow: '蓄力守穩',
    yijiTitle: '今日宜忌',
    overallIndex: '綜合指數',
    lifeElement: '命',
    scores: '分',
    clickToExpand: '點擊展開',
    clickToView: '點擊查看含義',
    luckySuffix: '是今日能量共振的顏色，穿戴或攜帶該色物品可提升今日氣場。',
    numberPrefix: '今日幸運數字為',
    numberAnd: '和',
    numberSuffix: '。可以將這些數字融入日常：選擇含有這些數字的時段行動，或者在重要決策時以這些數字為參考。數字能量是一種微妙的共振，用好了是額外的助力。',
    dirSuffix: '是今日能量聚集的方向，朝該方位行動或安排重要事務，有助於順勢借力。',
    timeSuffix: '是今日能量最順暢的時段，將最重要的事情安排在這個時辰，往往事半功倍。',
    actionItemTime: '在{{time}}專注處理最重要的事',
    actionItemDir: '朝{{dir}}方向出行或安排重要活動',
    actionHigh1: '主動拓展人脈 — 今日貴人運強',
    actionHigh2: '處理財務事項 — 正財氣場流暢',
    actionLow1: '低調穩健前行，避免衝動決策',
    actionLow2: '專注蓄力 — 今日的努力將在未來獲得回報',
    summaries: [
      '今日整體能量旺盛。事業有貴人相助，財運穩步上升。感情方面宜主動表達避免誤會。身體狀態良好，精力充沛。',
      '今日人脈活躍，社交互動順暢，適合拓展人脈與推進合作。財運小有波動，理性管理開支為宜。',
      '今日思維敏捷，效率極高。事業可能有好消息傳來，適合簽約與談判。感情溫馨和諧。',
      '今日運勢平穩，穩扎穩打是最佳策略。耐心等待，機會就在不遠處。健康需注意休息。',
      '今日財運上揚，有機會獲得意外收益。事業有貴人指點，方向更加清晰。單身者桃花運旺，緣分或許就在身邊。',
      '今日直覺敏銳，決策果斷。大部分計劃都能順利推進。與同事關係融洽，容易獲得認可。',
      '今日心情愉悅，正能量滿滿。適合處理拖延已久的事項，效率奇高。下午財運回升，把握時機。',
      '今日創意靈感湧現，適合藝術創作與頭腦風暴。工作思路清晰，團隊協作順暢。下午有吉兆。',
      '今日宜靜養，與其向外求助，不如專注內在積累，這將成為未來成長的基石。感情中真誠是最好的禮物。',
      '今日溝通能量強勁，談判、演講、銷售都能順利進行。財運達峰值，尤其下午後半段最為明顯。',
      '今日行動力強，任何事只要邁出第一步就能推進。感情生活增添新色彩，健康狀況令人滿意。',
      '今日堅持與細心是關鍵。適合回顧與反思，為下一階段目標打好基礎。',
    ],
    advices: [
      '宜：主動出擊、把握機遇、展現才華\n忌：情緒化決策、衝動選擇、為人擔保',
      '宜：積極社交、簽署協議、出行拜訪\n忌：單打獨鬥、爭執爭論、高風險投資',
      '宜：專注工作、穩步前進、整理財務\n忌：懶散拖延、大額非理性消費',
      '宜：廣結善緣、探索收入機會、助人為樂\n忌：斤斤計較、固執己見、因小失大',
      '宜：充電休息、恢復能量、整理思緒\n忌：過度操勞、情緒放縱、消耗儲備',
      '宜：創新探索、尋求突破、勇於嘗試新事物\n忌：因循守舊、猶豫不決、錯失良機',
      '宜：表達感恩、以溫情待人、建立良好關係\n忌：抱怨消極、口舌糾紛、訴訟爭議',
      '宜：相信直覺、果斷行動、掌握主動權\n忌：優柔寡斷、被他人左右、注意力分散',
      '宜：規劃整理、回顧總結、打好根基\n忌：追求速成、忽視細節、草率行事',
      '宜：團隊協作、共同腦暴、攜手成長\n忌：過度競爭、獨攬功勞、得罪同僚',
      '宜：以柔克剛、冷靜應對、修煉內心\n忌：輕率競爭、莽撞冒進、得罪貴人',
      '宜：三思後行、沉著處事、以靜制動\n忌：多言多語易錯、輕信謠言、急於決策',
    ],
    dimLove: {
      high: '愛情能量旺盛。感情進展順利自然，單身者魅力大增，戀愛中者感情升溫。今日表達心意，效果倍增。',
      mid: '愛情能量平穩，無大波瀾。以耐心和溫情經營感情。若有伴侶，今日一個小小的貼心舉動勝過千言萬語。',
      low: '愛情能量需要關注。可能有小摩擦出現，以理解替代評判，小挑戰共同面對能讓感情更堅固。',
    },
    dimCareer: {
      high: '事業能量強勁。思維清晰，效率卓越，貴人顯現。今日適合推進重要項目、拜訪新客戶或提出關鍵提案。',
      mid: '事業能量穩定。專注手頭任務，打磨細節即可，無需強求突破。整理文件、回覆信息、覆盤進展都能順利進行。',
      low: '事業能量稍弱。今日避免推動重大決策。利用這段時間做好準備、整理思路，為下一次行動打好基礎。',
    },
    dimWealth: {
      high: '財運能量上揚。正財收入順暢，偶有意外小進賬。小額穩健投資有利，避免孤注一擲。財務事項傾向正向結果。',
      mid: '財運能量均衡。收支保持平衡即可，避免衝動性大額消費。理性消費是今日關鍵詞。',
      low: '財運能量需謹慎。避免大額投資或不必要的開支。守住財務紀律、保護本金是今日最明智的財務選擇。',
    },
    dimHealth: {
      high: '健康能量絕佳。精力充沛，狀態極好。適合較高強度的運動，也適合社交活動與戶外探險。',
      mid: '健康能量穩定。注意勞逸結合，保證睡眠質量。避免熬夜，日常保養尤其有效。',
      low: '健康能量需關注。傾聽身體信號，避免過度操勞。休息比硬撐更有價值。若有不適及時就醫。',
    },
    luckyColors: {
      red: '紅色五行屬火，能激發熱情與行動力。今日穿紅色單品、使用紅色配飾，有助於提振精神，增強表達欲，感情事業均可借力。',
      gold: '金色象徵金氣，主財富與收益。今日使用金色裝飾或配件，有助於吸引正財氣場，適合處理財務相關事務。',
      white: '白色五行屬金，象徵純淨與專注。今日以白色為主色調，助力清晰思維，適合需要專注力的工作與創作。',
      blue: '藍色五行屬水，主智慧與溝通。今日搭配藍色元素，有助於思維流暢，表達清晰，適合談判、演講與學習。',
      green: '綠色五行屬木，主生機與成長。今日以綠色為幸運色，有助於新項目啟動，也有利於健康調養與心情放鬆。',
      purple: '紫色代表高貴與神秘，能量場偏向精神層面。今日使用紫色，有助於直覺敏銳，適合冥想、創意發散與深度思考。',
      orange: '橙色五行屬火，充滿暖意與活力。今日使用橙色元素，有助於增進人際關係，社交場合中顯得格外親切有感染力。',
      silver: '銀色與金色同屬金系，偏向內斂穩健。今日以銀色為幸運色，適合需要冷靜判斷的場合，財運方面偏向守成穩固。',
      black: '黑色五行屬水，能量內斂深沉。今日以黑色為主，適合需要專注和沉澱的場景，可將思維引向深度與本質。',
      yellow: '黃色五行屬土，主穩定與積累。今日以黃色為幸運色，有助於穩固根基，財富積累與人際信任均有正面輔助。',
      pink: '粉色屬於溫柔火系，主感情與親密關係。今日以粉色為幸運色，感情運勢得到輔助，適合約會、親子互動與表達愛意。',
      cyan: '青色介於綠與藍之間，主療癒與平衡。今日以青色為幸運色，有助於身心調和，平緩焦慮，是需要放鬆時的理想選擇。',
    },
    luckyDirs: {
      east: '東方五行屬木，象徵朝氣蓬勃、新生與開始。今日出行、工作面朝東方或向東出發，有助於激發行動力，開啟新機遇。',
      south: '南方五行屬火，象徵光明與成就。今日向南方活動，有助於名聲傳播、事業提升，適合拜訪貴人或進行公開展示。',
      west: '西方五行屬金，象徵收穫與兌現。今日向西方活動，有助於推動財務收益，適合回款、談判收尾與資產整理。',
      north: '北方五行屬水，象徵智慧與內省。今日向北方活動，有助於深度思考與沉澱，適合學習、研究與需要冷靜判斷的事宜。',
      southeast: '東南方兼具木火特質，主財運與名聲同旺。今日面向東南，財運與事業運雙線輔助，是一個積極出擊的方向。',
      northeast: '東北方五行屬土，主踏實積累。今日向東北活動，有助於穩固根基，適合長線投資布局與需要耐心推進的項目。',
      southwest: '西南方五行屬土，主人際和感情。今日向西南活動，有助於感情運勢提升，適合約會、家庭聚會或修復重要關係。',
      northwest: '西北方五行屬金，主貴人與領導力。今日向西北活動，有助於得到上級認可和貴人相助，適合面試、匯報與開拓人脈。',
    },
    luckyTimes: {
      zi: '子時（23-01時）水氣最旺，思維清晰，直覺敏銳。適合夜間靈感工作、冥想與內省，也是感情溝通的好時機。',
      chou: '丑時（01-03時）土氣凝重，宜靜養不宜強撐。此時若有重要靈感湧現，請記錄下來，待明日落實。',
      yin: '寅時（03-05時）木氣生發，萬物初醒。早起者將感受到一天中最清醒的頭腦，適合規劃當日最重要的目標。',
      mao: '卯時（05-07時）陽氣漸升，精神振奮。早晨的第一件事設定好方向，一天的運勢將按預期展開。',
      chen: '辰時（07-09時）土氣主事，宜穩妥推進。早上的第一輪重要溝通安排在辰時，效果最佳。',
      si: '巳時（09-11時）火氣漸旺，思維活躍，表達力強。適合開會、演講、銷售溝通和重要決策。',
      wu: '午時（11-13時）火氣最旺，能量達到峰值。此時行動力和感召力最強，適合推進最關鍵的事項。',
      wei: '未時（13-15時）土氣回歸，節奏放緩適合梳理。下午的整理與規劃讓後半天更加高效從容。',
      shen: '申時（15-17時）金氣漸顯，適合細節收尾和財務處理。下午三點後的時段是處理精確事項的好時機。',
      you: '酉時（17-19時）金氣旺盛，適合總結當日成果。傍晚時分的社交互動也容易留下良好印象。',
      xu: '戌時（19-21時）土氣收斂，適合家庭時光與情感陪伴。此時的感情互動最為真誠，宜好好珍惜與家人相處的時光。',
      hai: '亥時（21-23時）水氣生發，深夜靈感活躍。此時適合創意工作與深度閱讀，也是一天中內心最平靜的時段。',
    },
    zodiacTraits: {
      rat: {
        traits: [
          '思維敏捷，信息整合能力超強',
          '善於發現機會，行動迅速果斷',
          '社交能力強，容易建立廣泛人脈',
        ],
        advice: '今日發揮信息嗅覺，主動溝通，機會就在細節裡。',
      },
      ox: {
        traits: [
          '踏實穩健，做事有條不紊',
          '意志堅定，目標一旦確立絕不輕易放棄',
          '可靠誠信，是周圍人最信任的存在',
        ],
        advice: '今日以穩為主，專注眼前目標，厚積薄發。',
      },
      tiger: {
        traits: [
          '天生領袖，行動力與感召力俱佳',
          '勇於挑戰，不懼逆境敢闖敢拼',
          '熱情正直，對朋友真誠義氣',
        ],
        advice: '今日以行動力為先，率先出擊，機會屬於敢於行動的人。',
      },
      rabbit: {
        traits: [
          '細膩溫柔，對人對事體貼周到',
          '直覺敏銳，能感受到細微的情緒變化',
          '審美獨特，對美有超強的感知力',
        ],
        advice: '今日發揮共情優勢，以溫柔打動人心，感情與合作均宜。',
      },
      dragon: {
        traits: [
          '氣場強大，天生王者風範',
          '格局宏大，做事大氣不拘小節',
          '充滿熱情與魅力，容易成為眾人焦點',
        ],
        advice: '今日以大局為重，展現格局，貴人相助將自然而至。',
      },
      snake: {
        traits: [
          '直覺超強，洞察力令人嘆服',
          '深謀遠慮，一步一步穩穩推進',
          '具有神秘氣質，令人難以完全猜透',
        ],
        advice: '今日相信直覺，深思慎行，以洞察力把握最佳時機。',
      },
      horse: {
        traits: [
          '熱情豪放，充滿感染力',
          '行動力極強，執行速度超快',
          '直率坦誠，不喜繞彎子說話',
        ],
        advice: '今日將熱情與行動力完美結合，快速推進最重要的目標。',
      },
      goat: {
        traits: [
          '心思細膩，善解人意',
          '藝術天賦出眾，對美有極深感悟',
          '溫和包容，極少與人正面衝突',
        ],
        advice: '今日發揮溫柔力量，以理解與包容打開人心，感情事業皆宜。',
      },
      monkey: {
        traits: [
          '聰明機智，變通能力無與倫比',
          '創意豐富，總能找到出人意料的解法',
          '活躍樂觀，帶給周圍人歡樂',
        ],
        advice: '今日發揮創意與機變，打破常規思路，往往有意外收獲。',
      },
      rooster: {
        traits: [
          '自律認真，做事標準高質量高',
          '觀察細膩，不放過任何細節',
          '表達直接，說話有條有理',
        ],
        advice: '今日以專注和細心取勝，將完美主義轉化為實際成果。',
      },
      dog: {
        traits: [
          '忠誠正直，是最可靠的朋友',
          '正義感強，敢於為對的事情發聲',
          '保護意識強，珍視身邊重要的人',
        ],
        advice: '今日以真誠和原則贏得信賴，忠誠是今日最大的資產。',
      },
      pig: {
        traits: [
          '豁達樂觀，生活態度令人羨慕',
          '善良真誠，不藏心機以真心換真心',
          '享受生活，能從日常中發現幸福',
        ],
        advice: '今日以豁達之心面對一切，真誠待人，美好自會降臨。',
      },
    },
  },
  year: {
    yearFortune: '年運勢',
    dimensionTitle: '年度運勢詳解',
    dimensionHint: '點擊展開',
    careerLabel: '事業運',
    wealthLabel: '財運',
    loveLabel: '愛情運',
    healthLabel: '健康運',
    peakMonths: '順遂月份：',
    monthTitle: '12月運勢節點',
    monthHint: '點擊月份查看指引',
    levelUp: '旺',
    levelMid: '平',
    levelDown: '蓄',
    levelUpFull: '順遂',
    levelMidFull: '平運',
    levelDownFull: '蓄運',
    monthPeriod: '運期',
    scienceTitle: '年度關係說明',
    yearAnimalPrefix: '當年生肖',
    relationPrefix: '與屬',
    relationSuffix: '的關係：',
    scienceDesc: '命理年運分析基於地支關係：三合（最吉）→ 六合（吉）→ 相生（小吉）→ 平順（中）→ 相破（小注意）→ 相害（需調和）→ 相刑（需調整）→ 相衝（需順勢而為）→ 本命年（轉折期）。所有關係只是能量場提示，積極心態與行動才是創造命運的根本。',
    scores: '分',
    monthDescUp: '此為順遂期，能量充沛，貴人易現。積極推進重要目標，主動出擊，把握湧現的機會。',
    monthDescMid: '本月運勢平穩，踏實耕耘自有收獲。專注手頭工作，不必強求突破性進展。',
    monthDescDown: '此為蓄力階段，低調內修為主，避免大風險。將精力投入充電與規劃，為下一個旺期做準備。',
    summaries: {
      '三合': '今年為三合年，能量場高度契合，運勢鼎盛，貴人自然相助，大多事情順利推進。是大展拳腳的黃金年份。',
      '六合': '今年為六合年，陰陽調和，事業與感情雙豐收，人際關係和諧，整體運勢向好。',
      '相生': '今年為相生年，五行能量流通順暢，各方面運勢穩中有升，進展紮實，收穫豐盛。',
      '平顺': '今年運勢平和穩定，無大起大落。勤懇付出自有回報，保持節奏，成果自然顯現。',
      '本命年': '今年為本命生肖年，是重要的轉折節點，機遇與挑戰並存。靜心修煉，以柔克剛，迎接新一輪成長週期。',
      '相破': '今年運勢有所起伏，推進事情需要額外耐心。充分準備能有效化解挑戰，亦是考驗真性情的時刻。',
      '相害': '今年有害氣在場，人際方面需多加留意。多帶真誠少帶誤會，信任靠得住的人，穩步前行。',
      '相刑': '今年有刑氣影響，情緒與關係需更多關注。保持冷靜克制，內修自省，刑氣可化為助力。',
      '相冲': '今年太歲相衝，運勢波動較大。避免莽撞衝動，化解太歲沖，順勢而為。記住：最大的考驗往往孕育最大的成長。',
    },
    loveDescHigh: '今年愛情能量旺盛，桃花頻現。單身者有望遇見心儀對象，戀愛中者感情加深鞏固。',
    loveDescMid: '今年愛情能量穩定，以真誠和耐心經營感情，迎接踏實甜蜜的連結。適時表達關心，溫暖自然流動。',
    loveDescLow: '今年愛情能量需關注，情緒管理與溝通質量是關鍵。多一分耐心，少一分爭執，感情路自然打開。',
    careerDescHigh: '今年事業能量強勁，貴人相助，機會眾多。適合開拓新項目或謀求晉升，努力將有所回報。',
    careerDescMid: '今年事業能量穩步前進，勤懇耕耘出成果。積累經驗，夯實基礎，為下一次躍升做好準備。',
    careerDescLow: '今年事業有挑戰，將其視為磨練成長的機會。低調蓄勢，內修實力，轉機終會到來。',
    wealthDescHigh: '今年財運流通順暢，正財偏財均有起色。穩健理財為宜，是積累財富的好時期。',
    wealthDescMid: '今年財運均衡，收支持平無憂。穩定積累，理性消費即可。',
    wealthDescLow: '今年財運需謹慎，避免激進投資與大額借貸。持續小步累積，才是穩健生財之道。',
    healthDescHigh: '今年健康能量充沛，身體狀態良好。保持良好習慣，健康將成為事業強大的支撐。',
    healthDescMid: '今年健康穩定，注意作息與情緒管理，避免過勞。日常保養是最好的健康投資。',
    healthDescLow: '今年健康需格外關注，注意勞逸結合，傾聽身體信號，有不適及早處理。',
  },
  conflict: {
    taisuiTitle: '年太歲提示',
    taisuiDesc: '什麼是太歲？',
    taisuiExplain: '太歲是中國傳統命理中代表當年年神的概念，每年輪換，與不同生肖產生特定的能量關係（三合、六合、相衝、相害等）。這種關係影響該年的整體運勢走向，但並不決定命運——積極的行動與心態才是改寫命運的力量。',
    bannerTitle: '沖害刑破詳解',
    bannerSub: '了解能量場差異，調和為成長動力',
    conflictTitle: '能量相碰的生肖',
    conflictSub: '查看優化參考詳解 ↓',
    noConflict: '與各生肖相處和諧',
    noConflictSub: '無明顯沖害刑破，繼續保持',
    resolveTitle: '優化參考',
    resolveAdviceTitle: '綜合調和參考',
    scienceTitle: '沖害刑破·入門解讀',
    disclaimer: '命理提示能量場的差異，積極心態與行動才是真正調和的力量',
    relationNote: '與屬',
    relationSuffix: '關係：',
    levelWarn: '注意',
    levelCaution: '留意',
    status: {
      三合: '三合吉年',
      六合: '六合順年',
      相生: '相生輔助年',
      平顺: '平順之年',
      本命年: '本命年',
      相破: '相破注意年',
      相害: '相害謹慎年',
      相刑: '相刑調整年',
      相冲: '太歲相衝年',
    },
    tips: {
      三合: '今年太歲與您的生肖三合，是難得的順遂年份，積極進取可收獲豐盛成果！',
      六合: '今年太歲與您的生肖六合，陰陽調和，整體運勢順遂，適合穩步推進各項目標。',
      相生: '今年五行相生，能量流動順暢，穩中有進，踏實耕耘自有收獲。',
      平顺: '今年運勢平和穩健，無大起伏，保持穩定節奏，細水長流自見成效。',
      本命年: '今年是本命年，是重要的蛻變轉折期——不是凶年，而是蓄力轉型的關鍵節點。低調行事，靜心積累，以柔克剛方可順利度過。把這一年的努力當成未來三年騰飛的根基，你比自己以為的更有韌性。',
      相破: '今年太歲與您的生肖相破，合作計劃容易遭遇意外變故——不是你做得不夠好，而是外部時機的影響。提前備好多套方案，以應變力化解突發，守住春夏節奏、發力秋冬反彈是今年最優策略。',
      相害: '今年太歲與您的生肖相害，人際方面的隱性摩擦需要主動化解——早發現早溝通，不讓小誤會積累成大隔閡。以真誠和透明度守住人際底線，稳健前行自有收穫。',
      相刑: '今年太歲與您的生肖相刑，情緒管理是今年最值得投資的能力——凡事保持冷靜克制，把「證明自己」的衝動轉化為「專注精進」的行動。內修自省，刑氣可化為精進動力，這一年的修煉將成為未來最強的競爭壁壘。',
      相冲: '今年太歲相衝，是人生階段性轉型的重要信號——不是命運不公，而是舊格局正在被打破，新機遇正在成型。順勢而為、以柔化剛，減少硬碰硬，這一年的挑戰將成為你最寶貴的成長資產。低調蓄力，厚積薄發。',
    },
    types: {
      相冲: { label: '相衝', desc: '地支對衝（如子午、丑未），能量場正面碰撞，摩擦最為明顯，但處理得當可激發互補能量。' },
      相害: { label: '相害', desc: '六害關係，合作中容易生出無形阻礙，表現為隱性誤會或利益摩擦，坦誠溝通是最有效調和方式。' },
      相刑: { label: '相刑', desc: '三刑或二刑關係，情緒和權責摩擦為主，明確邊界和情緒管理可大幅降低影響。' },
      自刑: { label: '自刑', desc: '本命年中同地支相疊，自身能量內耗，宜靜養守成，避免衝動決策，低調蓄力方為上策。' },
      相破: { label: '相破', desc: '地支相破，合作成果容易遭意外變故，提前準備多套預案可有效調和影響。' },
    },
    generalAdvice: {
      rat: '屬鼠人遇到這些生肖時，保持理性溝通、主動化解矛盾是最佳策略。命理提示能量場的差異——積極心態完全可以將摩擦轉化為理解與成長。',
      ox: '屬牛人天生的穩重和耐心，正是面對相碰能量場的資產。保持沉穩不動搖，往往能等到局勢朝自己有利的方向轉變。',
      tiger: '屬虎人有天生的領導氣場，在遇到相碰生肖時，以大局為重、以包容而非對抗往往能化敵為友。',
      rabbit: '屬兔人溫和細膩，在處理相碰關係時，順其自然、以柔克剛是最有效的優化參考。',
      dragon: '屬龍人自帶王者氣場，在與相碰生肖相處時，以包容和大氣的格局回應，方顯龍的胸懷——聚人心成大事。',
      snake: '屬蛇人思慮深遠，在面對相碰時，以智慧化解而非硬碰，找到對方能接受的切入點——蛇的靈活是最強的化解力。',
      horse: '屬馬人熱情行動力強，遇到相碰生肖時，以冷靜判斷力、將熱情集中在真正重要的事上，效率最大化。',
      goat: '屬羊人心思細膩，善解人意。面對相碰能量場，溫柔表達需求、保持個人邊界——溫和而堅定地守護自身能量場。',
      monkey: '屬猴人靈活變通，面對相碰時，以天生的適應力化解——用智慧與幽默消解矛盾是猴的獨特優勢。',
      rooster: '屬雞人認真自律，在面對相碰時，讓專業能力說話——避免情緒化爭執，專注打磨真實力量化解外在壓力。',
      dog: '屬狗人忠誠正直，在處理相碰關係時，以公正的立場、真誠與原則化贏得最終的尊重與信賴。',
      pig: '屬豬人豁達大度，遇到相碰生肖時，以真誠和善意消解對立——用天生的溫暖建立信任，往往比硬碰更有效。',
    },
  },
  ninePurple: {
    bannerTitle: '九紫離火運',
    bannerSub: '2024 — 2043年 · 二十年大運期',
    bannerFire: '離卦·火',
    benefitTitle: '受益指數',
    benefitAxis: '九紫離火運受益度',
    noteTitle: '運勢利好詳析',
    noteSub: '點擊各板塊查看詳細解析 ↓',
    expandHint: '點擊查看詳細解析 →',
    collapseHint: '點擊收起詳析',
    adviceTitle: '把握九紫離火運建議',
    faqTitle: '什麼是九紫離火運？',
    scoreLabels: {
      极旺: '極旺受益',
      明显: '明顯受益',
      顺势: '順勢借力',
      借势: '借勢而行',
      磨砺: '磨礪提升',
    },
    faq: [
      { q: '九紫離火運是什麼？', a: '玄空飛星風水理論中，將180年劃分為9個20年運期，2024-2043年進入九運（九紫離火運），以離卦主事，離卦屬火，代表文明、光明、名聲與科技創新。' },
      { q: '為什麼影響生肖運勢？', a: '生肖五行與當運五行（火）的生剋關係，決定了這一時期各生肖能量場的順逆程度。火生土→土命最受益；同火→火命同氣最旺；木生火→木命付出得名；火剋金→金命需磨礪；水剋火→水命需借勢。' },
      { q: '受益低的生肖怎麼辦？', a: '命理分析是了解自身能量場的工具，而非命運的枷鎖。受益高的生肖應主動把握機遇，受益低的生肖應專注內修，順勢而為，積極的心態與行動才是真正改變命運的力量。' },
    ],
  },
  match: {
    bannerTitle: '十二生肖配對',
    bannerSub: '基於三合六合理論·嚴謹對稱評分',
    legendTitle: '評分含義速查',
    overviewTitle: '12生肖契合度全覽',
    topTitle: '最佳契合生肖 TOP 3',
    restTitle: '其他生肖配對詳情',
    restHint: '點擊展開分析',
    scienceTitle: '配對關係·入門解讀',
    scores: '分',
    legend: [
      { range: '93+分', label: '天作之合 💞', desc: '三合局，能量高度共振，合作與感情均為最佳。' },
      { range: '85-92', label: '相得益彰 💛', desc: '六合關係，陰陽互補，感情順暢，共事高效。' },
      { range: '70-84', label: '和諧融洽 💚', desc: '五行相生，相處融洽，友情與合作均有益。' },
      { range: '50-69', label: '互相包容 💙', desc: '無明顯沖剋，相處平和，需主動溝通維繫。' },
      { range: '35-49', label: '摩擦不斷 ⚡', desc: '存在相破或相害，需理解包容，以智慧化解差異。' },
      { range: '35以下', label: '能量相悖 🔥', desc: '相衝關係，能量場摩擦強，需成熟溝通方可相處。' },
    ],
    matchLabels: {
      天作之合: '天作之合',
      相得益彰: '相得益彰',
      和谐融洽: '和諧融洽',
      互相包容: '互相包容',
      平淡相处: '平淡相處',
      摩擦不断: '摩擦不斷',
      能量相悖: '能量相悖',
    },
    science: [
      { t: '三合（95+）', d: '寅午戌（虎馬狗）、申子辰（猴鼠龍）、亥卯未（豬兔羊）、巳酉丑（蛇雞牛），同局三合，氣場最相合，攜手可成大事。' },
      { t: '六合（85-92）', d: '子丑（鼠牛）、寅亥（虎豬）、卯戌（兔狗）、辰酉（龍雞）、巳申（蛇猴）、午未（馬羊），陰陽調和，相輔相成。' },
      { t: '相衝（25-32）', d: '地支對衝，如子午（鼠馬）、丑未（牛羊）等，能量場摩擦最強，成熟理性地溝通可化解大半。' },
    ],
  },
  hero: {
    representLabel: '代表人物',
    traitTitle: '的共同特質',
    traitHint: '點擊各特質了解詳解 ↓',
    traitDesc: '天生具有「',
    traitDesc2: '」的特質，這是命理能量場賦予的獨特天賦，在人生的重要關口往往能發揮出意想不到的力量。',
    similarTitle: '與',
    similarTitle2: '的相似之處',
    lessonTitle: '來自',
    lessonTitle2: '的人生啟示',
    historyTitle: '歷史名人名單',
    historySub: '點擊展開英雄運勢對照詳析 ↓',
    careerMatchLabel: '事業運勢對照',
    traitMatchLabel: '人格特質對照',
    lessonLabel: '的啟示',
    lessonPrefix: '對屬',
  },
  fortune: {
    bannerTitle: '流年運勢預測',
    bannerSub: '六年大勢',
    whatTitle: '什麼是流年運勢？',
    whatDesc: '流年運勢是根據每年太歲（當年值年生肖）與您的生肖之間的地支關係推算的年度能量走向。三合、六合為旺年，相衝、相害為蓄力年。高分年份宜大步前進，低分年份宜內修蓄勢——命運掌握在自己手中。',
    chartTitle: '六年運勢走勢圖',
    chartHint: '點擊柱形展開詳析',
    detailTitle: '逐年詳細分析',
    detailHint: '與圖表聯動',
    keyMonths: '關鍵月份：',
    scores: '分',
    relWith: '屬',
    relation: '·',
    levelLabels: {
      极旺: '★★★★★ 極旺之年',
      顺遂: '★★★★ 順遂之年',
      平稳: '★★★ 平穩之年',
      蓄力: '★★ 蓄力之年',
      磨砺: '★ 磨礪之年',
    },
    yearTips: {
      high: '能量場順遂，積極進取，大步邁進！',
      mid: '運勢平穩，踏實耕耘，厚積薄發。',
      low: '為蓄力階段，內修自省，靜待花開。',
    },
  },
  'boundaryReminder.title': '邊界提醒',
  'boundaryReminder.content': '生肖運勢以年柱為綱，揭示的是群體層面的能量趨勢。每個人的八字組合獨一無二，群體趨勢需結合個人實際情況來看待。',
};

export default zodiacDetail;
